export const products = [
    {
        id: "1",
        slug: "bolso-artesanal-bandera-colombiana",
        name_es: "Bolso Artesanal Bandera Colombiana",
        name_en: "Colombian Flag Handcrafted Bag",
        description_es:
            "Bolso artesanal inspirado en los colores de la bandera colombiana. Hecho a mano con materiales resistentes.",
        description_en:
            "Handcrafted bag inspired by the colors of the Colombian flag. Handmade with durable materials.",
        price: 85.0,
        category: "bolsos",
        images: ["https://storage.googleapis.com/gym_bt/wb-pics/bolso-artesanal-bandera-colombiana.png"],
        colors: ["Amarillo/Azul/Rojo"],
        featured: true,
        in_stock: true,
    },
    {
        id: "2",
        slug: "camisa-marimonda",
        name_es: "Camisa Marimonda",
        name_en: "Marimonda Shirt",
        description_es:
            "Camisa inspirada en el personaje tradicional del Carnaval de Barranquilla.",
        description_en:
            "Shirt inspired by the traditional Barranquilla Carnival character.",
        price: 65,
        category: "ropa",
        images: ["https://storage.googleapis.com/gym_bt/wb-pics/camisa-marimonda.jpg"],
        sizes: ["S", "M", "L", "XL"],
        colors: ["Multicolor"],
        featured: true,
        in_stock: true,
    },
    {
        id: "3",
        slug: "camisa-roja-toros",
        name_es: "Camisa Roja Toros",
        name_en: "Red Bulls Shirt",
        description_es:
            "Camisa roja con ilustraciones de toros inspiradas en la cultura festiva del Caribe colombiano.",
        description_en:
            "Red shirt with bull illustrations inspired by the festive culture of the Colombian Caribbean.",
        price: 62.0,
        category: "ropa",
        images: [
            "https://storage.googleapis.com/gym_bt/wb-pics/camisa-roja-toros.jpg",
        ],
        sizes: ["S", "M", "L", "XL"],
        colors: ["Rojo"],
        featured: false,
        in_stock: true,
    },
    {
        id: "4",
        slug: "camisa-sombrero-vueltiao",
        name_es: "Camisa Sombrero Vueltiao",
        name_en: "Vueltiao Hat Shirt",
        description_es:
            "Camisa con estampado del tradicional sombrero vueltiao, símbolo del Caribe colombiano.",
        description_en:
            "Shirt with print of the traditional vueltiao hat, symbol of the Colombian Caribbean.",
        price: 64.0,
        category: "ropa",
        images: [
            "https://storage.googleapis.com/gym_bt/wb-pics/camisa-sombrerovolteados.jpg",
        ],
        sizes: ["S", "M", "L", "XL"],
        colors: ["Blanco/Negro"],
        featured: true,
        in_stock: true,
    },
    {
        id: "5",
        slug: "camiseta-amarilla-jergas-caribenas",
        name_es: "Camiseta Amarilla Jergas Caribeñas",
        name_en: "Yellow Caribbean Slang T-Shirt",
        description_es:
            "Camiseta amarilla con frases y jergas típicas del Caribe colombiano.",
        description_en:
            "Yellow t-shirt with phrases and slang typical of the Colombian Caribbean.",
        price: 38.0,
        category: "ropa",
        images: [
            "https://storage.googleapis.com/gym_bt/wb-pics/camiseta-amarilla-jergas-caribenas.jpg",
        ],
        sizes: ["S", "M", "L", "XL"],
        colors: ["Amarillo"],
        featured: false,
        in_stock: true,
    },
    {
        id: "6",
        slug: "camiseta-blanca-marimondas-flores",
        name_es: "Camiseta Blanca Marimondas y Flores",
        name_en: "White Marimondas and Flowers T-Shirt",
        description_es:
            "Camiseta blanca con ilustraciones de marimondas y flores tropicales.",
        description_en:
            "White t-shirt with marimondas and tropical flower illustrations.",
        price: 40.0,
        category: "ropa",
        images: [
            "https://storage.googleapis.com/gym_bt/wb-pics/camiseta-blanca-marimondas-flores.jpg",
        ],
        sizes: ["S", "M", "L", "XL"],
        colors: ["Blanco"],
        featured: true,
        in_stock: true,
    },
    {
        id: "7",
        slug: "collar-flor-amarilla-roja",
        name_es: "Collar Flor Amarilla y Roja",
        name_en: "Yellow and Red Flower Necklace",
        description_es:
            "Collar artesanal con flor en tonos amarillo y rojo inspirado en la naturaleza tropical.",
        description_en:
            "Handcrafted necklace with yellow and red flower inspired by tropical nature.",
        price: 26.0,
        category: "accesorios",
        images: [
            "https://storage.googleapis.com/gym_bt/wb-pics/collar-flor-amarilla-roja.png",
        ],
        colors: ["Amarillo/Rojo"],
        featured: false,
        in_stock: true,
    },
    {
        id: "8",
        slug: "libro-hasta-agosto",
        name_es: "En Agosto Nos Vemos",
        name_en: "Until August",
        description_es:
            "Obra póstuma de Gabriel García Márquez publicada recientemente.",
        description_en:
            "Posthumous work by Gabriel García Márquez recently published.",
        price: 42.0,
        category: "libros",
        images: [
            "https://storage.googleapis.com/gym_bt/wb-pics/libro-gabriel-garcia-marquez-hasta-agosto.png",
        ],
        featured: true,
        in_stock: true,
    },
    {
        id: "9",
        slug: "manilla-bandera-colombia",
        name_es: "Manilla Bandera Colombia",
        name_en: "Colombia Flag Bracelet",
        description_es:
            "Manilla artesanal con los colores de la bandera colombiana.",
        description_en:
            "Handcrafted bracelet with the colors of the Colombian flag.",
        price: 15.0,
        category: "accesorios",
        images: [
            "https://storage.googleapis.com/gym_bt/wb-pics/manilla-bandera-colombia.png",
        ],
        colors: ["Amarillo/Azul/Rojo"],
        featured: false,
        in_stock: true,
    },
    {
        id: "10",
        slug: "top-mujer-flores",
        name_es: "Top Mujer Flores Tropicales",
        name_en: "Tropical Flower Women's Top",
        description_es:
            "Top femenino con estampado de flores tropicales inspirado en el Caribe colombiano.",
        description_en:
            "Women's top with tropical flower print inspired by the Colombian Caribbean.",
        price: 48.0,
        category: "ropa",
        images: ["https://storage.googleapis.com/gym_bt/wb-pics/top-mujer-flores.jpg"],
        sizes: ["XS", "S", "M", "L"],
        colors: ["Multicolor"],
        featured: true,
        in_stock: true,
    },
    {
        id: "11",
        slug: "turbante-blanco-verde",
        name_es: "Turbante Blanco y Verde",
        name_en: "White and Green Turban",
        description_es:
            "Elegante turbante en tonos blanco y verde, tejido a mano con algodón de alta calidad.",
        description_en:
            "Elegant turban in white and green tones, hand-woven with high-quality cotton.",
        price: 29.99,
        category: "accesorios",
        images: [
            "https://storage.googleapis.com/gym_bt/wb-pics/turbante-blanco-verde.png",
        ],
        colors: ["Blanco/Verde"],
        featured: true,
        in_stock: true,
    },
    {
        id: "12",
        slug: "vestido-guacamaya-flores",
        name_es: "Vestido Guacamaya y Flores",
        name_en: "Macaw and Flowers Dress",
        description_es:
            "Vestido vibrante con ilustraciones de guacamayas y flores tropicales.",
        description_en:
            "Vibrant dress with macaws and tropical flowers illustrations.",
        price: 250.0,
        category: "ropa",
        images: [
            "https://storage.googleapis.com/gym_bt/wb-pics/vestido-guacamaya-flores.png",
        ],
        sizes: ["XS", "S", "M", "L"],
        colors: ["Multicolor"],
        featured: true,
        in_stock: true,
    },
];
